import { render } from "./UpdatePrompt.vue?vue&type=template&id=3c36b565&scoped=true"
import script from "./UpdatePrompt.vue?vue&type=script&lang=js"
export * from "./UpdatePrompt.vue?vue&type=script&lang=js"

import "./UpdatePrompt.vue?vue&type=style&index=0&id=3c36b565&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c36b565"]])

export default __exports__